<template>
    <el-container style="width:100%;" v-loading.body="loading">
      <el-header>
        <el-row type="flex" align="middle">
          <el-col style="line-height: 60px;">
            <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
            <el-button
              round
              @click="exportExcel"
            >{{ generateCustomizeString('batchExportOrders') }}</el-button>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-row class="shop-data">
          <!-- <el-col :span="24" style="margin-top: 10px; border: 1px solid #e6e6e6; border-radius: 5px;">
            <el-row>
              <el-col :span="24">
                <div class="statistics-title">{{ generateCustomizeString('keyIndicator') }}</div>
              </el-col>
              <el-col :span="6" class="statistics">
                <div>{{ generateCustomizeString('totalToday') }}</div>
                <div
                  style="line-height: 40px; font-size: 24px;"
                >NZD ${{parseFloat(this.salesData.today_sales_amount / 100).toFixed(2)}}</div>
              </el-col>
              <el-col :span="6" class="statistics">
                <div>{{ generateCustomizeString('totalYesterday') }}</div>
                <div
                  style="line-height: 40px; font-size: 24px;"
                >NZD ${{parseFloat(this.salesData.yesterday_sales_amount / 100).toFixed(2)}}</div>
              </el-col>
              <el-col :span="6" class="statistics">
                <div>{{ generateCustomizeString('totalThisMonth') }}</div>
                <div
                  style="line-height: 40px; font-size: 24px;"
                >NZD ${{parseFloat(this.salesData.month_sales_amout / 100).toFixed(2)}}</div>
              </el-col>
              <el-col :span="6" style="padding: 40px 0 30px 30px;">
                <div>{{ generateCustomizeString('totalPrevMonth') }}</div>
                <div
                  style="line-height: 40px; font-size: 24px;"
                >NZD ${{parseFloat(this.salesData.last_month_sales_amount / 100).toFixed(2)}}</div>
              </el-col>
            </el-row>
          </el-col> -->
          <!-- <el-col :span="24" style="margin-top: 30px;">
            <el-form :inline="true" ref="searchForm" :model="searchForm">
              <el-form-item :label="generateCustomizeString('time')">
                <el-date-picker
                  v-model="searchForm.datePicker"
                  size="mini"
                  style="vertical-align: middle;"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :range-separator="generateCustomizeString('to')"
                  :start-placeholder="generateCustomizeString('startDate')"
                  :end-placeholder="generateCustomizeString('endDate')"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  size="mini"
                  @click="selectDate"
                  v-if="this.searchForm.datePicker"
                >{{ generateCustomizeString('confirm') }}</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="selectDate"
                  v-else
                  disabled
                >{{ generateCustomizeString('confirm') }}</el-button>
              </el-form-item>
            </el-form>
          </el-col> -->

          <!-- 过滤选项 start -->
          <el-row>
            <el-col :span="24">
              <el-form ref="filterForm" :inline="true" :model="filterForm" class="search-form-inline">
                <el-col :span="24">
                  <!-- 支付渠道 -->
                  <el-form-item :label="generateCustomizeString('paymentChannel')">
                    <el-select
                      v-model="filterForm.pay_type"
                      :placeholder="generateCustomizeString('payType')"
                    >
                      <el-option key="all" :label="generateCustomizeString('all')" value=""></el-option>
                      <el-option key="wechatPay" :label="generateCustomizeString('wechatPay')" value="IE002"></el-option>
                      <el-option key="alipay" :label="generateCustomizeString('alipay')" value="IE001"></el-option>
                      <el-option key="unionpay" :label="generateCustomizeString('unionpay')" value="IE0031"></el-option>
                      <el-option key="polipay" :label="generateCustomizeString('polipay')" value="IE0041"></el-option>
                      <el-option key="paypal" :label="generateCustomizeString('paypal')" value="IE0111"></el-option>
                      <el-option key="creditPay" :label="generateCustomizeString('creditPay')" value="IE8888"></el-option>
                      <el-option key="onfflinePay" :label="generateCustomizeString('onfflinePay')" value="IE9999"></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 支付状态 -->
                  <el-form-item :label="generateCustomizeString('paymentStatus')">
                    <el-select
                      v-model="filterForm.status"
                      :placeholder="generateCustomizeString('paymentStatus')"
                    >
                      <el-option key="paymentSuccess" :label="generateCustomizeString('paymentSuccess')" value="1"></el-option>
                      <el-option key="all" :label="generateCustomizeString('all')" value=""></el-option>
                      <el-option key="unpaid" :label="generateCustomizeString('unpaid')" value="0"></el-option>
                      <el-option key="refundSuccess" :label="generateCustomizeString('refundSuccess')" value="2"></el-option>
                      <el-option key="closed" :label="generateCustomizeString('closed')" value="99"></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 订单号 -->
                  <el-form-item :label="generateCustomizeString('orderId')">
                    <el-input :placeholder="generateCustomizeString('orderId')" v-model="filterForm.order_out_trade_no"></el-input>
                  </el-form-item>
                </el-col>

                <!-- 支付时间 -->
                <el-col>
                  <el-form-item
                    :label="generateCustomizeString('time')"
                  >
                    <el-date-picker
                      v-model="filterForm.datePicker"
                      type="daterange"
                      :range-separator="generateCustomizeString('to')"
                      :start-placeholder="generateCustomizeString('startDate')"
                      :end-placeholder="generateCustomizeString('endDate')"
                      style="width: 400px;"
                    ></el-date-picker>
                  </el-form-item>

                  <!-- 确认按钮 -->
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="filterData()"
                    >{{generateCustomizeString('searchSubmit')}}</el-button>
                    <el-button @click="onReset">{{generateCustomizeString('reset')}}</el-button>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-col>
          </el-row>
          <!-- 过滤选项 ends -->

          <!-- 交易列表 start -->
          <el-col>
            <el-table
              :data="transactionDetails"
              ref="multipleTable"
              tooltip-effect="dark"
              style="width: 100%; margin-bottom:60px;"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55" fixed="left"></el-table-column>
              <el-table-column prop="order_out_trade_no" :label="generateCustomizeString('orderId')">
                <template slot-scope="scope">
                  <span class="order-number">
                    <a @click="viewOrderClick(scope.row.order_id)">{{ scope.row.order_out_trade_no }}</a>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="transactionId" :label="generateCustomizeString('transactionId')">
                <template slot-scope="scope">
                  <span>{{ scope.row.out_trade_no }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="pay_type" :label="generateCustomizeString('paymentChannel')">
                <template slot-scope="scope">
                  <span>{{ scope.row.pay_type }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="fee" :label="generateCustomizeString('amount')">
                <template slot-scope="scope">
                  <span>{{ scope.row.fee | formatPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="username" :label="generateCustomizeString('username')"
              >
                <template slot-scope="scope">
                  <div @click="viewCustomer(scope.row.customer_id)" class="customer">
                    <span v-if="scope.row.customer.email">{{ scope.row.customer.email }}</span>
                    <span v-else-if="scope.row.customer.phone">{{ scope.row.customer.phone }}</span>
                    <span v-else-if="scope.row.customer.username">{{ scope.row.customer.username }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="status" :label="generateCustomizeString('paymentStatus')">
                <template slot-scope="scope">
                  <span>{{ generateCustomizeString(scope.row.status) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="created_at" :label="generateCustomizeString('createAt')">
                <template slot-scope="scope">
                  <span>{{ scope.row.created_at | toLocalTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="finished_at" :label="generateCustomizeString('finishTime')">
                <template slot-scope="scope">
                  <span v-if="scope.row.finished_at">{{scope.row.finished_at | toLocalTime }}</span>
                  <span v-else>N/A</span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <!-- 交易列表 ends -->
        </el-row>
      </el-main>

      <!-- 翻页 start -->
      <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
        <el-row type="flex">
          <el-col style="padding-top: 5px;">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="currentTotal"
            ></el-pagination>
          </el-col>
          <el-col>
            <div style="position: fixed; right: 30px;">
              <span style="font-size: 12px; color: #606266;">
                {{ generateCustomizeString('ordersPerPage') }}:
              </span>
              <el-select v-model="pageSize" style="width: 80px;" @change="filterData()">
                <el-option
                  v-for="item in numOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </el-footer>
      <!-- 翻页 ends -->
    </el-container>
</template>

<script>
import request from '@/utils/request'
import moment from 'moment'
import { generateCustomizeString } from '@/utils/i18n'
import XLSX from 'xlsx'
import XLSX_SAVE from 'file-saver'
import dayjs from 'dayjs'
// import { filter } from 'vue/types/umd'

const originFilterForm = {
  datePicker: [],
  pay_type: '',
  status: '1',
  order_out_trade_no: ''
}

export default {
  name: 'TransactionCenter',
  data() {
    return {
      nowTime: '',
      currentPage: 1,
      currentTotal: 0,
      pageSize: 10,
      time: this.generateCustomizeString('sevenDays'),
      // searchForm: Object.assign({}, originOrderSearchForm),
      filterForm: Object.assign({}, originFilterForm),
      loading: false,
      transactionDetails: [],
      filters: {},
      pickerOptions: {
        shortcuts: [
          {
            text: this.generateCustomizeString('last7Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.generateCustomizeString('last14Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.generateCustomizeString('last30Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      numOfOrders: 10,
      numOptions: [
        {
          value: 15,
          label: '15'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        },
        {
          value: 1000,
          label: '1000'
        }
      ],
      multipleSelection: [],
      exportData: []
    }
  },
  methods: {
    generateCustomizeString,
    viewCustomer(customerId) {
      console.log('viewCustomer')
      this.$router.push({
        name: 'MemberView',
        params: { memberId: customerId }
      })
    },
    viewOrderClick(id) {
      this.$router.push({
        name: 'OrderView',
        params: { orderId: id }
      })
    },
    filterData(val) {
      this.$refs.filterForm.validate(valid => {
        if (valid) {
          this.loading = true
          // const params = Object.assign({}, this.filterForm)
          const params = {}

          // 日期参数
          if (this.filterForm.datePicker.length === 2) {
            const dates = this.filterForm.datePicker.map(date =>
              moment(date).format('YYYY-MM-DD HH:mm:ss')
            )
            params.start_created_at = dates[0]
            params.end_created_at = dates[1]
            delete params.datePicker
          }

          // 支付渠道参数, 如果是微信支付或者支付宝, 传数组给接口(因为微信支付和支付宝有多种子分类)
          if (this.filterForm.pay_type === 'IE001') {
            console.log('x')
            params.pay_type = ['IE0011', 'IE0012', 'IE0013', 'IE0015']
          } else if (this.filterForm.pay_type === 'IE002') {
            console.log('y')
            params.pay_type = ['IE0021', 'IE0022', 'IE0023', 'IE0025']
          } else if (this.filterForm.pay_type !== '') {
            params.pay_type = [this.filterForm.pay_type]
          }

          // 支付状态参数
          if (this.filterForm.status !== '') {
            params.status = this.filterForm.status
          }

          // 订单号参数
          if (this.filterForm.order_out_trade_no !== '') {
            params.order_out_trade_no = this.filterForm.order_out_trade_no
          }
          this.filters = params
          this.fetchTransactionDetails(val)
        } else {
          console.log('data error')
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.filterData(1)
    },
    handleCurrentChange(val) {
      this.filterData(val)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    fetchTransactionDetails(page) {
      request({
        url: '/transaction/list',
        method: 'get',
        params: {
          page: page,
          page_size: this.pageSize,
          ...this.filters
        }
      })
        .then(res => {
          if (res.status === 0) {
            const data = res.data
            const meta = res.meta
            this.transactionDetails = data
            for (var i = 0; i < this.transactionDetails.length; i++) {
              this.transactionDetails[i].pay_type = this.getPayTypeName(this.transactionDetails[i].pay_type)
              this.transactionDetails[i].status = this.getPaymentStatusName(this.transactionDetails[i].status)
            }
            this.currentPage = meta.current_page
            this.currentTotal = meta.total
          }
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onReset() {
      this.filterForm.pay_type = ''
      this.filterForm.status = ''
      this.filterForm.order_out_trade_no = ''
      this.filterForm.datePicker = []
    },
    getPayTypeName(typeId) {
      const alipayIds = ['IE0011', 'IE0012', 'IE0013', 'IE0015']
      const wechatPayIds = ['IE0021', 'IE0022', 'IE0023', 'IE0025']
      if (alipayIds.includes(typeId)) {
        return this.generateCustomizeString('alipay')
      } else if (wechatPayIds.includes(typeId)) {
        return this.generateCustomizeString('wechatPay')
      } else if (typeId === 'IE0031') {
        return this.generateCustomizeString('unionpay')
      } else if (typeId === 'IE0041') {
        return this.generateCustomizeString('PoliPay')
      } else if (typeId === 'IE0111') {
        return this.generateCustomizeString('paypal')
      } else if (typeId === 'IE8888') {
        return this.generateCustomizeString('creditPay')
      } else if (typeId === 'IE9999') {
        return this.generateCustomizeString('offlinePayment')
      }
    },
    getPaymentStatusName(statusId) {
      switch (statusId) {
        case 0:
          return 'unpaid'
        case 1:
          return 'paymentSuccess'
        case 2:
          return 'refundSuccess'
        case 99:
          return 'closed'
      }
    },
    exportExcel() {
      const selections = this.$refs.multipleTable.selection
      if (selections.length === 0) {
        alert(this.generateCustomizeString('pleaseSelectTransactions'))
        return
      }
      let ids = ''
      for (var i = selections.length - 1; i >= 0; i--) {
        ids += selections[i].id
        if (i !== 0) ids += ','
      }
      console.log(ids)
      // this.$refs.paidExcel.handleExcelClick(ids)
      this.downloadFile(ids)
    },
    downloadFile(ids) {
      // 每次执行导出excel之前先清空一下exportData数据
      this.exportData = []
      // get filterred export items
      const filterredData = this.getFilterredData(ids)
      console.log(filterredData)

      // 整理要导出的数据
      for (let i = 0; i < filterredData.length; i++) {
        const tempItem = {
          [this.generateCustomizeString('createAt')]: filterredData[i].created_at,
          [this.generateCustomizeString('finishTime')]: filterredData[i].finished_at ? filterredData[i].finished_at : 'N/A',
          [this.generateCustomizeString('orderId')]: filterredData[i].order_out_trade_no,
          [this.generateCustomizeString('transactionId')]: filterredData[i].out_trade_no,
          [this.generateCustomizeString('paymentChannel')]: filterredData[i].pay_type,
          [this.generateCustomizeString('amount')]: this.$options.filters.formatPrice(filterredData[i].fee),
          [this.generateCustomizeString('paymentStatus')]: filterredData[i].status
        }
        const item = JSON.parse(JSON.stringify(tempItem))
        this.exportData.push(item)
      }
      // 导出文件的名字
      const fileName = dayjs().local().format('YYYY-MM-DD_HH-mm-ss')
      /* make the worksheet */
      var ws = null

      ws = XLSX.utils.json_to_sheet(this.exportData, {
        skipHeader: false
      })
      /* write workbook (use type 'binary') */
      var csv = XLSX.utils.sheet_to_csv(ws)

      /* prepend UTF-8 BOM */
      const str = '\ufeff' + csv

      /* force a download */
      XLSX_SAVE.saveAs(
        new Blob([str], { type: 'application/octet-stream' }),
        'Transaction_Data_' + fileName + '.csv'
      )
    },
    getFilterredData(ids) {
      const tempData = []
      for (let i = 0; i < this.transactionDetails.length; i++) {
        if (ids.includes(this.transactionDetails[i].id)) {
          tempData.push(this.transactionDetails[i])
        }
      }
      return tempData
    },
    onRefersh() {
      this.onReset()
      this.filterData(1)(this.currentPage)
    }
  },
  mounted: function() {
    var date = new Date()
    this.nowTime =
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1) +
      '-' +
      date.getDate() +
      ' ' +
      '00:00:00'
    this.filterData(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header, .el-footer {
  background-color: #eee;
  color: #333;
}
.order-number, .customer {
  text-decoration: underline;
  color: #409EFF;
  cursor: pointer;
}
</style>
